import { Plugin } from "prosemirror-state";
import { isReactNativeWebViewContext, postMessage, } from "../../rn-webview-integration/integration";
/**
 * Create a plugin that uses the given provider to open details about a mention when the node is clicked.
 */
export const openMentionDetailsOnClick = (schema, mentionService) => {
    return new Plugin({
        props: {
            handleClickOn: (view, _pos, node) => {
                if (node.type === schema.nodes.mention) {
                    const attrs = node.attrs;
                    const target = view.dom.querySelector(`[mention-id="${attrs.id}"]`);
                    if (isReactNativeWebViewContext()) {
                        postMessage({ type: "mention", attrs });
                        return true;
                    }
                    mentionService.openDetails(attrs, target);
                    return true;
                }
                return false;
            },
        },
    });
};
